import { FC } from 'react';
import { useRoutes } from 'react-router-dom';
import { path } from '../../paths';
import { onBasePath } from '../../paths/onBasePath';
import { ClassifierDirectory } from './ClassifierDirectory';
import { ClassifierEdit } from './ClassifierEdit';
import { ClassifierCreate } from './ClassifierCreate';
import { ClassifierClone } from './ClassifierClone';
import { ClassifierBreadcrumbsData } from './ClassifierBreadcrumbs.types';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import { ClassifierDetail } from './ClassifierDetail';
import translations from './Classifiers.translations.json';
import { NotFound } from '../NotFound';

export const { addTranslations, useTranslation, Translation } =
  i18nNsFactory('classifiers-page');
addTranslations(translations);

export const CLASSIFIER_ROUTES = [
  {
    path: path.classifierDirectory,
    renderBreadcrumb: () => (
      <Translation>{(t) => t('breadcrumb.classifiers')}</Translation>
    ),
    children: [
      {
        index: true,
        element: <ClassifierDirectory />,
      },
      {
        path: path.classifierCreate,
        element: <ClassifierCreate />,
        renderBreadcrumb: () => (
          <Translation>{(t) => t('breadcrumb.classifier-create')}</Translation>
        ),
      },
      {
        path: path.classifierView,
        element: <ClassifierDetail />,
        renderBreadcrumb: (data?: ClassifierBreadcrumbsData) =>
          data?.classifier ? (
            `${data.classifier.code} - ${data.classifier.name}`
          ) : (
            <Translation>
              {(t) => t('breadcrumb.classifier-detail')}
            </Translation>
          ),
      },
      {
        path: path.classifierEdit,
        element: <ClassifierEdit />,
        renderBreadcrumb: (data?: ClassifierBreadcrumbsData) =>
          data?.classifier ? (
            `${data.classifier.code} - ${data.classifier.name}`
          ) : (
            <Translation>{(t) => t('breadcrumb.classifier-edit')}</Translation>
          ),
      },
      {
        path: path.classifierClone,
        element: <ClassifierClone />,
        renderBreadcrumb: () => (
          <Translation>{(t) => t('breadcrumb.classifier-clone')}</Translation>
        ),
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export const Classifiers: FC<{ basePath: string }> = ({ basePath }) =>
  useRoutes(onBasePath(basePath, CLASSIFIER_ROUTES));
